import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TranslateKeyPipe } from 'src/app/pipes/translate-key/translate-key.pipe';
import { LanguageKey } from 'src/main/translate/language-key/language-key';

@Component({
  selector: 'app-post-create-notice-dialog',
  standalone: true,
  templateUrl: './post-create-notice-dialog.component.html',
  imports: [CommonModule, DialogModule, ButtonModule, TranslateKeyPipe],
})
export class PostCreateNoticeDialogComponent {
  @Input() visible = false;
  @Input() titleKey: LanguageKey = LanguageKey.POST_CREATE_CHILD_NOTICE_TITLE;
  @Input() messageKey: LanguageKey | null = null;

  @Output() finished = new EventEmitter<void>();

  public readonly languageKey = LanguageKey;

  confirm(): void {
    this.finished.emit();
  }
}
